import type { CSSProperties } from 'react';
import { DateTime } from '@ksyos/date-time';
import { FormParagraph } from '@ksyos/design-system';

export interface IFormattedDate {
    style?: CSSProperties;
    value?: Date | string | null;
}

export function FormattedDate(props: IFormattedDate) {
    let date: DateTime | null = null;
    if (props.value) {
        if (typeof props.value === 'string' && props.value.length === 10) {
            date = DateTime.parseUtc(props.value, 'YYYY-MM-DD');
        }
        date = DateTime.from(props.value);
    }

    return <FormParagraph style={props.style}>{date ? date.format('DD-MM-YYYY') : '-'}</FormParagraph>;
}
